import { analyticBrandAdvocatesActions } from 'store/actions';
import { IAnalyticBrandAdvocatesMeta } from 'store/actions/analytics/brandAdvocates';
import { GenericResponse } from 'types/GenericResponse';
import { createAsyncReducer } from 'utils/Redux';

export default createAsyncReducer<IAnalyticBrandAdvocatesMeta, GenericResponse>(
  analyticBrandAdvocatesActions,
);
